import React, { useState } from "react";
import { Form, FormGroup, Input, Label } from "reactstrap";
import { Btn, H4, P } from "../../../AbstractElements";
import { Eye, EyeOff, Lock } from "react-feather";
import { getStoredUser, logout, unlockSession } from "../../../api/auth";
import credoraToast from "../Common/credoraToast";
import { brandLogo } from "../../../assets/brand/credoraLogos";
import { getFrontendBaseUrl } from "../../../constants/appBase";

const SessionLockOverlay = ({ onUnlocked }) => {
  const user = getStoredUser();
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!password || submitting) {
      return;
    }
    setSubmitting(true);
    try {
      await unlockSession(password);
      setPassword("");
      credoraToast.success("Session unlocked.");
      onUnlocked();
    } catch (err) {
      const detail = err.response?.data?.detail;
      credoraToast.error(detail, "Incorrect password.");
    } finally {
      setSubmitting(false);
    }
  };

  const handleSignOut = () => {
    logout();
    localStorage.removeItem("credora_user");
    window.location.href = `${getFrontendBaseUrl()}/login`;
  };

  return (
    <div className="credora-session-lock" role="dialog" aria-modal="true" aria-label="Session locked">
      <div className="credora-session-lock__panel">
        <div className="credora-session-lock__brand">
          <img src={brandLogo} alt="Credora" height={36} />
        </div>
        <div className="credora-session-lock__icon">
          <Lock size={28} />
        </div>
        <H4 attrH4={{ className: "credora-session-lock__title" }}>Session locked</H4>
        <P attrPara={{ className: "credora-session-lock__subtitle text-muted" }}>
          {user?.full_name ? (
            <>
              Signed in as <strong>{user.full_name}</strong>. Enter your password to continue.
            </>
          ) : (
            "Enter your password to continue."
          )}
        </P>

        <Form onSubmit={handleSubmit} className="credora-session-lock__form">
          <FormGroup>
            <Label for="session-unlock-password" className="visually-hidden">
              Password
            </Label>
            <div className="credora-session-lock__password-wrap">
              <Input
                id="session-unlock-password"
                type={showPassword ? "text" : "password"}
                placeholder="Password"
                value={password}
                autoComplete="current-password"
                autoFocus
                disabled={submitting}
                onChange={(e) => setPassword(e.target.value)}
              />
              <button
                type="button"
                className="credora-session-lock__toggle"
                onClick={() => setShowPassword((v) => !v)}
                aria-label={showPassword ? "Hide password" : "Show password"}
              >
                {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
              </button>
            </div>
          </FormGroup>
          <Btn
            attrBtn={{
              color: "primary",
              className: "w-100",
              type: "submit",
              disabled: !password || submitting,
            }}
          >
            {submitting ? "Unlocking…" : "Unlock"}
          </Btn>
        </Form>

        <button type="button" className="credora-session-lock__signout btn btn-link" onClick={handleSignOut}>
          Sign out instead
        </button>
      </div>
    </div>
  );
};

export default SessionLockOverlay;
